export enum GeneralMessageType {
  CONFIRMATION = 'CONFIRMATION',
  NOTICE = 'NOTICE',
  ERROR = 'ERROR'
}
